import { API, graphqlOperation } from 'aws-amplify';
import { getUserRole } from '@/graphql/queries';
import { ERROR_TYPES } from '../constants/constants';

export const getUserAsync = (userID) =>
  API.graphql(graphqlOperation(getUserRole, { id: userID })).catch((res) => {
    if (
      res.errors.some((error) => (error.errorType = ERROR_TYPES.Unauthorized))
    ) {
      return { data: { getUserRole: null } };
    }
    throw res;
  });
